import AuthGuard from 'app/auth/AuthGuard';
import dashboardRoutes from 'app/views/dashboard/DashboardRoutes';
import NotFound from 'app/views/sessions/NotFound';
import sessionRoutes from 'app/views/sessions/SessionRoutes';
import { Navigate } from 'react-router-dom';
import MatxLayout from './components/MatxLayout/MatxLayout';
import ProfilePage from './views/profile/profilePage';

const routes = [
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [...dashboardRoutes],
  },
  ...sessionRoutes,
  { path: '/', element: <Navigate to="/session/signin" /> },
  { path: '/center', element: <Navigate replace="dashboard/center" /> },
  { path: '/manager', element: <Navigate replace="dashboard/manager" /> },
  { path: '/user-profile', element: <ProfilePage /> },
  { path: '*', element: <NotFound /> },
];
export default routes;
